import store from 'src/js/store';
import selectors from '../selectors';
import { SELECT } from '../constants/trigger-types';

function findAllFor(element, triggerType = SELECT) {
  const state = store.getState();
  const registeredTools = selectors.getTools(state);
  const filteredTools = registeredTools.filter((tool) => tool.triggerOn === triggerType);
  return filteredTools.filter((tool) => tool.matches(element));
}

export default findAllFor;
